import type {Slide, SourceSpan} from './model';

/** Trim rendered text while retaining offsets around an excluded notes block. */
export function mapSlideBody(source: string, excluded?: {from: number; to: number}) {
  const parts = excluded ? [
    {text: source.slice(0, excluded.from), start: 0},
    {text: '\n', start: null},
    {text: source.slice(excluded.to), start: excluded.to},
  ] : [{text: source, start: 0}];
  const joined = parts.map(part => part.text).join('');
  const body = joined.trim();
  const left = joined.length - joined.trimStart().length;
  const right = left + body.length;
  const spans: SourceSpan[] = [];
  let offset = 0;
  for (const part of parts) {
    const from = Math.max(offset, left);
    const to = Math.min(offset + part.text.length, right);
    if (part.start !== null && to > from) {
      spans.push({from: from - left, to: to - left, sourceFrom: part.start + from - offset});
    }
    offset += part.text.length;
  }
  return {body, spans};
}

/** A block spanning hidden notes is deliberately not rewritten as one edit. */
export function slideBlockRange(slide: Slide, from: number, to: number) {
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < from) return;
  const span = slide.sourceSpans.find(span => from >= span.from && to <= span.to);
  if (!span) return;
  return {from: span.sourceFrom + from - span.from, to: span.sourceFrom + to - span.from};
}
